import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  CardTitle, 
  CardSubtitle, 
  CardBody, 
  Form, 
  FormGroup, 
  Input, 
  Alert 
} from 'reactstrap';
import { Button, FormFeedback } from '../Forms';
import { doClearResetPassword, doRequestResetPassword } from '../../actions/resetPasswordAction';
import { isEmail } from '../../helpers/regex';

/*
type State = {
  email: string,
  _error: ?Object,
  _submit: Boolean,
  _isFetch: Boolean
}

type Props = {
  status_code: number,
  message: string
}
*/

const AlertSuccess = ({status_code, message, children}) => {
  return (
    status_code === 200 ?
      <Alert className="no-border-radius" color="success">
          <h4 className="alert-heading">Well done!</h4>
          <p>{`${message}`}</p>
          <hr/>
          <p><Link to='login' className="link link-dark">Back to Login</Link></p>
      </Alert>
    :
      children
  )
}
class PageForgotPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			_error: null,
      _submit: false,
      _isFetch: false
		}
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
    const { userdata } = this.props.dataAuth;
    if (userdata.status_code === 200){
      this.setState({
        email: userdata.email
      })
    }
		this.props.load();
  }

  componentDidUpdate(prevProps, prevState) {
    const { userdata } = this.props.dataAuth;
    if (prevProps.dataAuth.userdata.isFetch !== userdata.isFetch) {
      if (userdata.isFetch && !this.state._isFetch) {
        this.setState({
          _isFetch: userdata.isFetch
        });
      }
      else if (!userdata.isFetch && this.state._isFetch) {
        this.setState({
          _isFetch: !this.state._isFetch,
          email: userdata.email
        })
      }
    }
  }

	componentWillReceiveProps(nextProps) {
		if (this.state._submit === true && nextProps.dataReset.isSubmit !== this.props.dataReset.isSubmit && nextProps.dataReset.isSubmit === false){
			if (nextProps.dataReset.error) {
				this.setState({_submit:false,_error:{...nextProps.dataReset.error}})
			}
			else
				this.setState({_submit:false})
		}
	}

	onChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
	}
	_validateForm() {
		let errors = {};
		if (this.state.email === '')
			errors['email']=errors['email'] !== undefined  ?[...errors.email,'Harap isi email.']:['Harap isi email.'];
		if (!isEmail(this.state.email))
			errors['email']=errors['email'] !== undefined ? [...errors.email,'Alamat email tidak valid.']:['Alamat email tidak valid.'];
		if (Object.keys(errors).length){
			this.setState({
				_error:{errors:{...errors}, status_code:422,message:'Please fulfill your form'}
			})
		}
		return errors;
	}
	onForgetPassword(e) {
		e.preventDefault();
		this.setState({_error:null})
		if (!Object.keys(this._validateForm()).length) {
			this.setState({_submit:true},() => {
				const {email} = this.state;
				this.props.submit({email})
			})
		}
	}

    hasError(name) {
        if(this.state._error !== null && this.state._error.status_code === 422) {
            return Object.keys(this.state._error.errors).filter(err=>err === name).length > 0;
        }
        return false;
	}

    renderError() {
        if(this.state._error !== null){
            const {status_code, message} = this.state._error;
            switch(status_code) {
                case 422:
                    return (
                        <Alert className="no-border-radius" color="danger">
                            <strong>Oh snap!</strong> Please fullfill your form.
                        </Alert>
                    )
                default:
                    return (
                        <Alert className="no-border-radius" color="danger">
                            <strong>Oh snap!</strong> {message}
                        </Alert>
                    )
            }
        }
        return '';
	}

	render() {
		return (
			<div>
				<Container className="main-container page-container">
					<Row>
						<Col xs={12} md={{size:6, offset:3}}>
							<Card className="no-border-radius">
								<CardBody>
									<CardTitle className="text-center">Forgot Password</CardTitle>
									<CardSubtitle>
										Please enter your email address below. You will receive a link to reset your password.
									</CardSubtitle>
								</CardBody>
								<CardBody>
									<AlertSuccess status_code={this.props.dataReset.data.status_code}  message={this.props.dataReset.data.message}>
										<div>
											{this.renderError()}
											<Form onSubmit={this.onForgetPassword.bind(this)}>
												<FormGroup className={classnames({'has-error':this.hasError('email')})}>
													<Input name="email" onChange={this.onChange.bind(this)} className={classnames("form-control__input--black-lighter",{'is-invalid':this.hasError('email')})} type="text" value={this.state.email} placeholder="Enter your correct email*"/>
													<FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="email"/>
												</FormGroup>
												<FormGroup>
													<Button className="btn-green bold" block size="lg" disabled={this.state._submit} buttonText="Submit"/>
													<div style={{marginTop:15}}>
														<span>Or</span>{'  '}
														<Link to="login">
															Back to Login
														</Link>
													</div>
												</FormGroup>
											</Form>
										</div>
									</AlertSuccess>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}


const mapStateToProps = state => {
    return {
        dataReset: state.dataResetPassword,
        dataAuth: state.dataAuth,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(doClearResetPassword()),
        submit: (payload) => dispatch(doRequestResetPassword(payload))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(PageForgotPassword);
